export enum ImageFormat {
    Jpg = 'jpg',
    Jpeg = 'jpeg',
    Png = 'png',
    Webp = 'webp',
    Heic = 'heic',
    Avif = 'avif',
}